"use strict";
/**
 * @programmatic_validator for EMailInput
 */

var Validate = require('src/UI/integrated_fork/Validate');

var validator = (function(uniqueID, options) {
	
	// E-Mail validation
	var constraints = {
		email : {
			message: "^This address doesn't look like a valid E-Mail"
		},
		presence : {
			allowEmpty: false,
			message: "^The E-Mail address is required"	// when validating single values, validate.js neither know which name to use nor uses the default message, 
		}
	}
	
	return constraints;
})();

module.exports = validator;
//validator.__factory_name = 'eMailInputStdValidator';
//module.exports = Factory.Maker.getClassFactory(styleDef);